import React from "react";
import { useNavigate } from "react-router-dom";
import FormatListNumberedRoundedIcon from "@mui/icons-material/FormatListNumberedRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
const Optiontap = () => {
  const navigate = useNavigate();
  const subItem = [
    {
      title: "โพยหวย",
      link: "/historylottery",
      icon: <ReceiptLongRoundedIcon />,
    },
    {
      title: "ผลหวย",
      link: "/resultlottery",
      icon: <ManageSearchRoundedIcon />,
    },
    {
      title: "สร้างโพย",
      link: "/betnumset",
      icon: <FormatListNumberedRoundedIcon />,
    },
  ];

  return (
    <div>
      <div className="grid grid-cols-3 gap-2 px-2 py-3">
        {subItem.map((data, i) => (
          <div key={i} className="col-span-1">
            <button className={` w-full text-sm text-[#b3853e]`}>
              <div
                className="text-center px-1 border border-[#b3853e] rounded py-1"
                onClick={() => navigate(data.link)}
              >
                {/* <div className="inline-block p-2 text-center rounded-full bg-gradient-to-t from-[#b3853e] to-[#b3853e]">
                  <div className="text-sx text-[#f8eede]">{data.icon}</div>
                </div>
                <p className="text-center text-normal text-defaultText4 mt-1 font-bold">
                  {data.title}
                </p> */}
                {data.icon}
                {data.title}
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Optiontap;
